import { motion } from "framer-motion";
import "./About.css";

function About() {
  const features = [
    { 
      title: "Rapid Response Time", 
      text: "We don't keep you waiting. Our local Cape Town dispatch ensures a technician is on-site within minutes, not hours." 
    },
    { 
      title: "Certified & Insured", 
      text: "Security is a serious business. Our technicians are fully vetted, background-checked, and carry comprehensive insurance." 
    },
    { 
      title: "Advanced Security Tech", 
      text: "From traditional lock repairs to smart-home access systems, we use the latest technology to keep you safe." 
    }
  ];

  return (
    <section className="about" id="about">
      <div className="container about-wrapper">
        <motion.div 
          className="about-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="about-tag">OUR COMMITMENT</span>
          <h2>Cape Town's Preferred Security Professionals</h2>
          <p>
            At the heart of our service is one simple goal: <strong>restoring your sense of security.</strong> 
            Whether you’ve lost your keys in the CBD, need to upgrade your business perimeter, 
            or require an urgent residential repair, we combine old-school craftsmanship with 
            modern security standards. 
          </p>
          <p>
            We don't just open doors—we secure your peace of mind with transparent pricing, 
            expert advice, and a 24/7 commitment to our local community.
          </p>
          <a href="#contact" className="about-btn">Request A Consultation</a>
        </motion.div>

        <div className="about-features">
          {features.map((feature, index) => (
            <motion.div 
              className="feature"
              key={index}
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="feature-number">0{index + 1}</div>
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;